import React, { useEffect, useState } from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import logoVerPerfil from '../assets/logoVerPerfil.png';
import logoFiltro from '../assets/Filter.png';
import { arreglarReloj, handleError, toastError, toastSuccess } from '../funciones';
import axios from '../axiosConfig';
import { TablaN } from './TablaN';
import { FiltrosAdmin } from './FiltrosAdmin';
import logoAprobar from '../assets/logoAprobar.png';
import logoDesaprobar from '../assets/logoDesaprobar.png';
import qs from "qs";
import { useCompaniesQuery } from '../hooks/useCompaniesQuery';
import { useAnimatedMount } from '../hooks/useAnimatedMount';
import { ViewProfileCompany } from './ViewProfileCompany';
export const EmpresasInvitadas = ({ evento, funciones, nombreBuscar, uniones, empresasInvitadas, show }) => {
    //const [elementos, setElementos] = useState([]);
    const [invitada, setInvitada] = useState('0');
    //const [mostrarLoader, setMostrarLoader] = useState(true);
    const itemsFiltro = [
        {
            setValue: setInvitada, value: invitada, id: "filtroInvitada", text: "Estado",
            items: ["Todas", "No invitadas", "Invitadas"]
        }
    ];
    const { mounted, visible } = useAnimatedMount(show);

    const [selectedCompanyId, setSelectedCompanyId] = useState(null);

    const unionesValues = uniones?.length
        ? uniones.map(u => u.value)
        : null;
    const { companies, loading, updateCompany } = useCompaniesQuery(
        "empresa/todasLasEmpresas",

        {
            size: 100000,
            /*params: {
                size: 100000,
                uniones: unionesValues
            },
            paramsSerializer: params =>
                qs.stringify(params, { arrayFormat: "repeat" })*/
        },
        !!evento && !!uniones
    );

    useEffect(() => {
        if (show) funciones.updateHandlerRef.current = updateCompany;
    }, [updateCompany, show]);

    const selectedCompany = companies?.find(
        c => c.id === selectedCompanyId
    );

    useEffect(() => {
        selectedCompany && show && funciones.setSelectedCompany(selectedCompany)
    }, [selectedCompany])

    /*useEffect(() => {
        if (!uniones?.length) return;
        setMostrarLoader(true);
        const unionesValues = uniones?.length
            ? uniones.map(u => u.value)
            : null;

        axios.get(
            process.env.REACT_APP_URL + 'empresa/todasLasEmpresas',
            {
                params: {
                    size: 100000,
                    uniones: unionesValues
                },
                paramsSerializer: params =>
                    qs.stringify(params, { arrayFormat: "repeat" })
            }
        ).then(function (response) {
            setElementos(response.data.content);
        }).catch(function (error) {
            toastError(handleError(error))
        }).finally(() => {
            setMostrarLoader(false)
        })


        //}
    }, [evento, uniones])*/

    const invitadasSet = React.useMemo(() => {
        return new Set(empresasInvitadas?.map(e => e.id));
    }, [empresasInvitadas]);

    function mostrarEmpresa(elem) {
        const estaInvitada = invitadasSet.has(elem.id);

        let nombreAprobado = true;
        if (
            nombreBuscar !== "" &&
            !elem.nombre
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                    nombreBuscar
                        .toLowerCase()
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")
                )
        ) {
            nombreAprobado = false;
        }

        return (
            invitada === "0" ||
            (invitada === "1" && !estaInvitada) ||
            (invitada === "2" && estaInvitada)
        ) && nombreAprobado;
    }

    function contenidoFila(elem) {
        const estaInvitada = invitadasSet.has(elem.id);

        return (
            <>
                <div className='col'>{elem.nombre}</div>

                <div className='col-3 text-center'>
                    {estaInvitada ? 'Invitada' : 'No invitada'}
                </div>

                <div className='col-3 text-end d-flex justify-content-end'>
                    <img
                        className='cursor-pointer img-blanco-mobile'
                        src={!estaInvitada ? logoAprobar : logoDesaprobar}
                        alt=""
                        onClick={() => cambiarInvitada(elem.id, !estaInvitada)}
                    />

                    {/*<img
                        className='ms-3 cursor-pointer img-blanco-mobile'
                        src={logoVerPerfil}
                        alt=""
                        data-bs-toggle="modal"
                        data-bs-target="#modalPerfil"
                        onClick={() => {
                            funciones.setPerfil(elem);
                            funciones.setIdElemSeleccionado(elem.id);
                        }}
                    />*/}
                    <ViewProfileCompany companyId={elem.id} onSelect={setSelectedCompanyId} />
                </div>
            </>
        );
    }

    useEffect(() => {
        if (!empresasInvitadas?.length) return;
        const idsElementos = new Set(companies.map(el => el.id));

        funciones.setEmpresasInvitadas(prev => {
            const filtradas = prev.filter(inv => idsElementos.has(inv.id));

            // 🛑 si no cambia, NO seteamos estado
            if (filtradas.length === prev.length) {
                return prev;
            }

            return filtradas;
        });

    }, [companies]);

    function cambiarInvitada(id, invitar) {
        if (invitar) {
            funciones.setEmpresasInvitadas(prev =>
                prev.some(e => e.id === id)
                    ? prev
                    : [...prev, { id }]
            );
        } else {
            funciones.setEmpresasInvitadas(prev =>
                prev.filter(e => e.id !== id)
            );
        }
    }

    function mostrarFiltros() {
        document.getElementById("containerFiltros").classList.remove("ocultarFiltros")
        document.getElementById("filtroOverlay").classList.remove("ocultarFiltros")
    }
    return (
        <>
            {mounted && <>

                <TablaN elementos={companies} id={'containerInvitados'} classNameTabla={visible ? "transform-none" : ''}
                    itemsEncabezado={[{ className: 'col', text: 'Empresas' },
                    { className: 'col-3 text-center', text: 'Estado' },
                    { className: 'col-3', text: '' },
                    {
                        className: 'position-absolute end-0 w-fit-content centrarContainer',
                        text: <>
                            <img src={logoFiltro} className='cursor-pointer me-3 mobile-white d-inline-block' alt="" onClick={mostrarFiltros} />
                        </>
                    }]}
                    itemsFilas={contenidoFila} elemNoEncontrado={'empresas'}
                    mostrarElem={mostrarEmpresa} mostrarLoader={loading} />
                <FiltrosAdmin itemsFiltro={itemsFiltro} />
            </>
            }
        </>
    );
}
